"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var auth_1 = require("../auth");
var FloatingLabelInput_1 = require("./FloatingLabelInput");
var ErrorMessageComponent_1 = require("./ErrorMessageComponent");
var constants_1 = require("../constants");
var CommonHeader_1 = require("./CommonHeader");
var react_intl_1 = require("react-intl");
require("font-awesome/css/font-awesome.min.css");
var App_1 = require("./App");
var glamor_1 = require("glamor");
var index_1 = require("../config/index");
require("react-toastify/dist/ReactToastify.css");
var react_toastify_1 = require("react-toastify");
//unable to import image using 'import statement' as file extension is tsx
var img = require('../greenBackground.jpg');
var SignInStyle_1 = require("./SignInStyle");
var SignIn = function (props) {
    var context = react_1.useContext(App_1.LanguageContext);
    var _a = react_1.useState(''), userName = _a[0], setUserName = _a[1];
    var _b = react_1.useState(''), password = _b[0], setPassword = _b[1];
    var _c = react_1.useState(true), showSignIn = _c[0], setShowSignIn = _c[1];
    var _d = react_1.useState(false), inlineErrorUser = _d[0], setInlineErrorUser = _d[1];
    var _e = react_1.useState(false), inlineErrorPassword = _e[0], setInlineErrorPassword = _e[1];
    var _f = react_1.useState(false), pass = _f[0], setPass = _f[1];
    var _g = react_1.useState(false), showMessage = _g[0], setShowMessage = _g[1];
    var _h = react_1.useState(''), message = _h[0], setMessage = _h[1];
    var _j = react_1.useState(false), loading = _j[0], setLoading = _j[1];
    var _k = react_1.useState(false), showToast = _k[0], setshowToast = _k[1];
    var providerType = auth_1.InfoAuth.getConfig().provider.type;
    react_1.useEffect(function () {
        setshowToast(props.email ? true : false);
        if (providerType === constants_1.AuthProviderEnum.MICROSOFT_AD || providerType === constants_1.AuthProviderEnum.MICROSOFT_AD_INFO_APPS) {
            signIn();
        }
    }, []);
    var signIn = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, authUser, session, accessToken, authUser, session, accessToken, err_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = providerType;
                    switch (_a) {
                        case constants_1.AuthProviderEnum.MICROSOFT_AD_INFO_APPS: return [3 /*break*/, 1];
                        case constants_1.AuthProviderEnum.MICROSOFT_AD: return [3 /*break*/, 1];
                    }
                    return [3 /*break*/, 5];
                case 1:
                    setLoading(true);
                    return [4 /*yield*/, auth_1.InfoAuth.signIn(userName, password, context.language)];
                case 2:
                    authUser = _b.sent();
                    if (!(authUser != null)) return [3 /*break*/, 4];
                    return [4 /*yield*/, auth_1.InfoAuth.currentSession()];
                case 3:
                    session = _b.sent();
                    accessToken = session.accessToken.token;
                    console.log('accessToken: ', accessToken);
                    _b.label = 4;
                case 4:
                    setShowSignIn(true);
                    window.location.reload();
                    _b.label = 5;
                case 5:
                    if (userName === '') {
                        setInlineErrorUser(true);
                        setPass(false);
                        setShowMessage(false);
                        setMessage('');
                        setLoading(false);
                    }
                    if (password === '') {
                        setInlineErrorPassword(true);
                        setPass(false);
                        setShowMessage(false);
                        setMessage('');
                        setLoading(false);
                    }
                    authUser = void 0;
                    if (!(userName !== '' && password !== '')) return [3 /*break*/, 11];
                    _b.label = 6;
                case 6:
                    _b.trys.push([6, 10, , 11]);
                    setLoading(true);
                    return [4 /*yield*/, auth_1.InfoAuth.signIn(userName, password, context.language)];
                case 7:
                    authUser = _b.sent();
                    if (!(authUser != null)) return [3 /*break*/, 9];
                    return [4 /*yield*/, auth_1.InfoAuth.currentSession()];
                case 8:
                    session = _b.sent();
                    accessToken = session.accessToken.token;
                    console.log('accessToken: ', accessToken);
                    _b.label = 9;
                case 9:
                    setShowSignIn(true);
                    window.location.reload();
                    return [3 /*break*/, 11];
                case 10:
                    err_1 = _b.sent();
                    setLoading(false);
                    if (err_1.message != null) {
                        if (err_1.code === constants_1.ErrorCodeEnum.PENDING_CHANGE_PASSWORD) {
                            props.history.push({
                                pathname: '/changePassword',
                                state: {
                                    userName: userName
                                }
                            });
                        }
                        else if (err_1.code === constants_1.ErrorCodeEnum.PENDING_VERIFICATION) {
                            {
                                index_1.default.verificationType === 'code' ?
                                    props.history.push({
                                        pathname: '/confirmSignUp',
                                        state: {
                                            email: userName, userId: err_1.userId, showToast: true
                                        }
                                    }) :
                                    setshowToast(true);
                                react_toastify_1.toast.success("User verification pending. Check email", {
                                    autoClose: 10000,
                                    className: glamor_1.css({
                                        backgroundColor: 'rgb(227, 252, 239)!important',
                                        boxShadow: 'rgba(0, 0, 0, 0.176) 0px 3px 8px !important',
                                        color: 'rgb(0, 102, 68)  !important',
                                        transform: 'translate3d(0px, 0px, 0px)',
                                        borderRadius: '4px',
                                        borderLeft: '5px solid rgb(54, 179, 126) !important',
                                        transition: 'transform 220ms cubic-bezier(0.2, 0, 0, 1) 0s'
                                    })
                                });
                            }
                        }
                        else {
                            setPass(false);
                            setShowMessage(true);
                            setMessage(err_1.message);
                        }
                    }
                    return [3 /*break*/, 11];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    if (providerType !== constants_1.AuthProviderEnum.MICROSOFT_AD && providerType !== constants_1.AuthProviderEnum.MICROSOFT_AD_INFO_APPS) {
        return (React.createElement("div", null,
            React.createElement(CommonHeader_1.default, __assign({}, props, { setLanguage: context.setLanguage })),
            showToast && React.createElement(react_toastify_1.ToastContainer, { hideProgressBar: true }),
            showSignIn && (React.createElement(SignInStyle_1.LoginContainer, { image: img },
                React.createElement(SignInStyle_1.WrapperContainer, null,
                    React.createElement(SignInStyle_1.Form, null,
                        React.createElement(SignInStyle_1.LoginSpanContainer, { showMessage: showMessage },
                            React.createElement("strong", null,
                                React.createElement(react_intl_1.FormattedMessage, { id: "signin.login" }))),
                        React.createElement(ErrorMessageComponent_1.default, { pass: pass, showMessage: showMessage, message: message }),
                        React.createElement(FloatingLabelInput_1.FloatingLabelInput, { id: "userId", dispalyLabel: React.createElement(react_intl_1.FormattedMessage, { id: "signin.email" }), onChange: setUserName, value: userName, inlineError: inlineErrorUser, setInLineError: setInlineErrorUser, type: "text", inlineMsg: "Email is required" }),
                        React.createElement("br", null),
                        React.createElement(FloatingLabelInput_1.FloatingLabelInput, { id: "Password", dispalyLabel: React.createElement(react_intl_1.FormattedMessage, { id: "signin.password" }), onChange: setPassword, value: password, inlineError: inlineErrorPassword, setInLineError: setInlineErrorPassword, type: "password", inlineMsg: "Password is required" }),
                        React.createElement("br", null),
                        React.createElement(SignInStyle_1.CustomButton, { size: "lg", loading: loading, onClick: signIn, className: 'submit' },
                            React.createElement(react_intl_1.FormattedMessage, { id: "signin.signin" })),
                        React.createElement(SignInStyle_1.RedirectContainer, null,
                            index_1.default.forgetPasswordRequired && React.createElement(SignInStyle_1.LinkComponent, { to: "/forgotPassword" },
                                React.createElement(SignInStyle_1.LinkSpan, { showMessage: showMessage },
                                    React.createElement(react_intl_1.FormattedMessage, { id: "signin.forgotpassword" }))),
                            index_1.default.signUpRequired && React.createElement(SignInStyle_1.LinkComponent, { to: "/signUp" },
                                React.createElement(SignInStyle_1.LinkSpan, { showMessage: showMessage },
                                    React.createElement(react_intl_1.FormattedMessage, { id: "signin.signup" }))))))))));
    }
    else {
        return (React.createElement(React.Fragment, null));
    }
};
exports.default = react_intl_1.injectIntl(react_router_dom_1.withRouter(SignIn));
//# sourceMappingURL=SignIn.js.map